<template>
	<div class="body-content magazine-viewport">
		<el-image-viewer v-if="previewImg" :on-close="closeViewer"
			:url-list="pdfimg">
		</el-image-viewer>
		<div class="container">
			<div id="magazine">
				<!-- Next button -->
				<div v-if="page != allPages.length" ignore="1" class="next-button next-button-hover" @click="nextButton"></div>
				<!-- Previous button -->
				<div v-if="page !=1" ignore="1" class="previous-button previous-button-hover" @click="previousButton"></div>
				<div v-for="(item, index) in allPages" :key="index">
					<div class="text" :style="'background-image: url('+item.url+');'" @click="openViewer(item.url)">
						<footer v-if="index != 0 && index !== allPages.length-1" class="current-page">
							<div v-if="(index) % 2 == 0" class="even-numbers">
								{{ index+1 }}
							</div>
							<div v-else class="odd-number">{{ index+1 }}</div>
						</footer>
					</div>
				</div>
			</div>
		</div>
		
		
	</div>
</template>
<script>
	import turn from '@/utils/turn.js'
	import http from "@/utils/http";
	import ElImageViewer from 'element-ui/packages/image/src/image-viewer'
	export default {
		name: "FenMian2",
		data() {
			return {
				value: "",
				page: 1,
				previewImg:false,
				pdfimg:[],
				id: this.$route.query.id,
				title: this.$route.query.title,
				allPages:[],
				
			};
		},
		created() {
		},
		async mounted() {
			let self = this;
			const loginInfo = JSON.parse(window.sessionStorage.getItem('user') || null)
			let res1 = await http.post('api/picture/personl_periodical_detail', {
				id: this.id,
				uid: loginInfo.id
			})
			let qk_pdfimg = res1.data.data.list.qk_pdfimg?JSON.parse( res1.data.data.list.qk_pdfimg ):[];
			self.allPages = qk_pdfimg
			console.log(self.allPages)
			$("#magazine").turn("center");
			$("#magazine").turn("page");
			this.$nextTick(() => {
				$("#magazine").turn({
					display: "double",
					elevation: 50,
					duration: 100,
					gradients: true,
					autoCenter: true,
					acceleration: true,
					page: self.page,
					pages:self.allPages.length,
					width: 1000,
					when: {
						turned: function(e, page, pages) {
							self.page = page
						}
					}
				});
			});
		},
		methods: {
			
			openViewer(e){
				this.pdfimg = [e]
				this.previewImg = true
			},
			closeViewer() {
				this.previewImg = false
			},
			nextButton(){
				if(this.page<this.allPages.length){
					$('#magazine').turn('next');
				}
			},
			previousButton(){
				if(0<this.page){
					$('#magazine').turn('previous');
				}
			},
			
			
		},
		components: {ElImageViewer}
	};
</script>
<style>
	body {
		padding: 0;
		margin: 0;
	}
	.body-content{
		display: flex;
		flex-direction: column;
		align-items: center;
		justify-content: center;
		height: 100vh;
		width: 100%;
		background: #1a99f2;
		overflow: hidden;
		position: relative;
	}
	.container{
		position: absolute;
		
		
		width: 1000px;
		margin: auto;
	}

	.text {
		background-size: 100% 100%;
		width: 100%;
		height: 752px;
	}

	#magazine {
		width: 1000px;
		height: 752px;
	}

	.current-page {
		position: absolute;
		bottom: 0;
		width: 100%;
		text-align: center;
		font-size: 14px;
	}

	.even-numbers {
		width: 30px;
		height: 30px;
		background: #ffcc66;
		color: #fff;
		right: 0;
		position: absolute;
		bottom: 0px;
		line-height: 30px;
		text-align: center;
	}

	.odd-number {
		position: absolute;
		bottom: 0px;
		width: 30px;
		height: 30px;
		background: #cc00ff;
		color: #fff;
		line-height: 30px;
		text-align: center;
	}

	#magazine .shadow,
	#magazine.shadow {
		-webkit-box-shadow: 0 4px 10px #666;
		-moz-box-shadow: 0 4px 10px #666;
		-ms-box-shadow: 0 4px 10px #666;
		-o-box-shadow: 0 4px 10px #666;
		box-shadow: 0 4px 10px #666;
	}

	#magazine .turn-page {
		background-color: #ccc;
		background-size: 100% 100%;
	}

	.bookmark {
		margin-left: 633px;
		font-size: 20px;
		writing-mode: tb-rl;
		display: flex;
		align-items: center;
		justify-content: center;
		text-align: center;
		padding-top: 47px;

	}

	.item:nth-child(2n) {
		background: #ccc;
		width: 45px;
		height: 150px;
	}

	.item {
		width: 45px;
		height: 160px;
		background: red;
	}

	.item:nth-child(1) {
		z-index: 4;
		text-shadow: 6px 6px 6px #999;
	}

	.item:nth-child(2) {
		z-index: 3;
		text-shadow: 6px 6px 6px #333;
	}

	.item:nth-child(3) {
		z-index: 2;
		text-shadow: 6px 6px 6px #333;
	}

	.item:nth-child(4) {
		z-index: 1;
		text-shadow: 6px 6px 6px #333;
	}
	
	
	
.next-button, .previous-button{
	width:22px;
	height:100%;
	position:absolute;
	top:0;
}

.magazine-viewport .next-button{
	right:-22px;
	-webkit-border-radius:0 15px 15px 0;
	-moz-border-radius:0 15px 15px 0;
	-ms-border-radius:0 15px 15px 0;
	-o-border-radius:0 15px 15px 0;
	border-radius:0 15px 15px 0;
}

.magazine-viewport .previous-button{
	left:-22px;
	-webkit-border-radius:15px 0 0 15px;
	-moz-border-radius:15px 0 0 15px;
	-ms-border-radius:15px 0 0 15px;
	-o-border-radius:15px 0 0 15px;
	border-radius:15px 0 0 15px;
}

.magazine-viewport .previous-button-hover,
.magazine-viewport .next-button-hover{
	background-color:rgba(255,255,255, 0.2);
}

.magazine-viewport .previous-button-hover,
.magazine-viewport .previous-button-down{
	background-image:url(../../../imges/arrows.png);
	background-position:-4px 284px;
	background-repeat:no-repeat;
}

.magazine-viewport .previous-button-down,
.magazine-viewport .next-button-down{
	background-color:rgba(0,0,0, 0.4);
}

.magazine-viewport .next-button-hover,
.magazine-viewport .next-button-down{
	background-image:url(../../../imges/arrows.png);
	background-position:-38px 284px;
	background-repeat:no-repeat;
}


</style>
